// extracted by mini-css-extract-plugin
export default {"form-container":"public_form-container__QC6iL","password-input":"public_password-input__-P6Gy"};